// Shared react-select style overrides so multi-value pills render with
// white text on the blue background — matches the canonical pattern in
// `src/Page/Assets.jsx`.
const materioMultiSelectStyles = {
  multiValue: (base) => ({
    ...base,
    backgroundColor: '#3980c0',
    borderRadius: '4px',
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: 'white',
    padding: '2px 6px',
  }),
  multiValueRemove: (base) => ({
    ...base,
    color: 'white',
    '&:hover': {
      backgroundColor: '#2e669a',
      color: 'white',
    },
  }),
};

export default materioMultiSelectStyles;
